import type { FieldValuesResponse, SaveFieldValueResponse } from "@repo/shared/types";
import { get, patch } from "../_client";

const BASE = "/internal/flow-instances";

export function getFieldValues(id: string) {
  return get<FieldValuesResponse>(`${BASE}/${id}/field-values`);
}

export function saveFieldValue(
  id: string,
  data: { fieldId: string; value: string; goalId?: string; portfolioId?: string },
) {
  return patch<SaveFieldValueResponse>(`${BASE}/${id}/field-values`, data);
}
